<ng-container *transloco="let t">
    <div class="px-4 sm:px-8 md:px-16 py-2 md:p-8 header-background">
        <div class="flex flex-col md:flex-row mt-8 md:mt-16 mb-8 md:mb-16 gap-8">
            <div class="w-full md:basis-1/2 flex flex-col">
                <h2 class="text-3xl sm:text-4xl md:text-5xl font-semibold"
                    [innerHTML]="bannerOptions?.i18nTitleKey | transloco"></h2>
                <ul class="space-y-4 mt-8">
                    <li class="flex items-center" *ngFor="let point of bannerOptions?.points">
                        <img class="bullent-point-icon" src="/assets/icons/custom/square_tick.svg">
                        <div class="ml-4">
                            <h2 class="text-xl font-bold"> {{t(point.i18nTitleKey)}}</h2>
                            <p>
                                {{t(point.i18nDescriptionKey)}}
                            </p>
                        </div>
                    </li>
                </ul>
                <div class="mt-10 md:mt-20">
                    <button mat-flat-button class="bg-primary text-black w-full sm:w-auto sm:min-w-48"
                            (click)='navigateTo(bannerOptions?.buttonOptions.url, bannerOptions?.buttonOptions?.routerLinkOptions)'
                       >{{t(bannerOptions?.buttonOptions.i18nTitleKey)}}
                    </button>
                </div>
            </div>

            <div class="hidden md:block md:basis-1/2">
                <img class="max-w-full" [src]="bannerOptions?.imageUrl">
            </div>
        </div>
    </div>
</ng-container>
